
 enum StatusWindow {
    Text = 1,
    Error,
    Warning,
    Info
}
export default StatusWindow;



// WEBPACK FOOTER //
// ./~/modal-window/src/status-window.ts